import { AuthorizedPersonDto } from "./authorized-person.data.models";
import { ClientInfoDto } from "./Company-info.data.models";
import { CompanyCityDto, NationalAddressDto } from "./national-address.data.models";

export interface OpportunityDetails {
    "attachments": FundAttachmentOutputDto[],
    "companyId": string,
    "companyType": string,
    "companyNameAr": string,
    "companynameEn": string,
    "companyName": string,
    "companyDescriptionAr": string,
    "companyDescriptionEn": string,
    "companyDescription": string,
    "companylogoUrl": string,
    "companyAddressAr": string,
    "companyAddressEn": string,
    "companyAddress": string,
    "contactPerson": string,
    "contactPhone": string,
    "contactFax": string,
    "contactEmail": string,
    "websiteURL": string,
    "facebookURL": string,
    "linkedInURL": string,
    "twitterURL": string,
    "instagramURL": string,
    "companyLatitude": number,
    "companyLongitude": number,
    "averageRate": number,
    "reviewsCount": number,
    "youTubeURL": string,
    "opportunityid": string,
    "projectTotalValue": number,
    "totalUnits": number,
    "durationPerMonth": number,
    "unitPrice": number,
    "organizerNameAr": string,
    "organizerNameEn": string,
    "organizerName": string,
    "projectIdeaAr": string,
    "projectIdeaEn": string,
    "projectIdea": string,
    "investmentFundId": string,
    "investmentStartDate": Date,
    "investmentEndDate": Date,
    "investmentFundLogoUrl": string,
    "shariahSupervisoryNameAr": string,
    "shariahSupervisoryNameEn": string,
    "shariahSupervisoryName": string,
    "fundType": string,
    "intervalProfit": number,
    "fundingPolicyAr": string,
    "fundingPolicyEn": string,
    "fundingPolicy": string,
    "expectedTotalProfit": string,
    "fundLocationAr": string,
    "fundLocationEn": string,
    "fundLocation": string,
    "subscriptionsNetWorth": string,
    "fundLatitude": number,
    "fundLongitude": number,
    "custodianNameEn": string,
    "custodianNameAr": string,
    "custodianName": string,
    "developer": string,
    "fundManagerNameEn": string,
    "fundManagerNameAr": string,
    "fundManagerName": string,
    "regualatorNameEn": string,
    "regualatorNameAr": string,
    "regualatorName": string,
    "janaCoverageShare": number,
    "minimumInvestment": number,
    "maximumInvestment": number,
    "fundStrategyNameAr": string,
    "fundStrategyNameEn": string,
    "fundStrategyName": string,
    "dividendPolicyen": string,
    "dividendPolicyAr": string,
    "dividendPolicy": string,
    "soldUnits": number,
    "isCompleted": boolean,
    "soldPercentage": number,
    "fundNameEn": string,
    "fundNameAr": string,
    "fundName": string,
    "isFundClosed": boolean,
    "janaCommission": number,
    "commissionVat": number,
    "isInclusive": boolean,
    "actualUnitPrice": number,
    "commissionPerUnit": number,
    "commissionVatPerUnit": number,
    "isUpcoming": boolean,
    "isAcceptSustainabilityReport": boolean,
    "isAcceptCustomerAcknowledgement": boolean,
    "isInCompleted": boolean
    "riskLevel": any

}
export enum CompanyProfileDocuments {
  NationalAddress = 1,
  ArticlesOfIncorporation,
  CommercialRegistration,
}

export enum FinancialAndTaxDocuments {
  AuditedFinancialStatements_LastTwoYears = 1,
  TaxAndZakatCertificate,
  IBANCertificate,
}

export enum AdditionalCompanyProfileDocument {
  AdditionalDocument = 1,
  MyCountryLicense = 2
}

export enum FundAttachmentType {
  BankStatementLast12Months = 1,
  BankStatement2025 = 2,
  TaxDeclarations2025 = 3,
  AdditionalDocument = 4,
  ArticlesOfIncorporation = 5,
  AuditedFinancialStatements_LastTwoYears = 6,
  CommercialRegistration = 7,
  IBANCertificate = 8,
  MyCountryLicense = 9,
  NationalAddress = 10,
  TaxAndZakatCertificate = 11,
  GosiCertificate = 12,
  OfferPriceDocument = 13,
  CompanyActivityAnalysisArabic = 14,
  CompanyActivityAnalysisEnglish = 15,
  CreditApprovalMemo = 16,
  SupplierDeliveryNotes = 17,
  BorrowerFinancingContractSignedCopy = 18,
  ManagementFeesPaymentReceipt = 19,
  MurabahaAprCalculator = 20,
  SimahReport = 21,
  FormalPurchaseOrder = 22,
  SuretyPerformanceBond = 23,
}


export interface FundAttachmentOutputDto {
    investmentFundId: string;  // Guid -> string in TypeScript
    fundFileTypeId: string;
    fundFileTypeNameAr: string;
    fundFileTypeNameEn: string;
    attachments: AttachmentDto[];  // List<AttachmentDto> -> AttachmentDto[] in TypeScript
}
export interface AttachmentDto {
    id: string;  // Guid -> string in TypeScript
    documentTypeId: string;
    titleAr: string;
    titleEn: string;
    pdfUrlAr: string;
    pdfUrlEn: string;
}
export interface OpportunityBookingSummary {
    "totalAvailableUnits": number,
    "totalSoldUnitsPerInvestor": number,
    "canInvest": boolean,
    "maximumInvestUnits": number,
    "investmentEndDate": Date,
    "minimumInvestUnits": number,
    "finalMaxInvestUnits": number
}
export interface PreBookingFundReport {
    "id": string,
    "investmentFundId": string,
    "nameAr": string,
    "nameEn": string,
    "descriptionAr": string,
    "descriptionEn": string,
}
export interface AcknowledgmentsReport {
    "id": string,
    "titleArabic": string,
    "titleEnglish": string,
    "detailsAr": string,
    "detailsEn": string,
}
export interface UpdateOpportunityTermsInput {
    "isAcceptCustomerAcknowledgement": boolean,
    "isAcceptSustainabilityReport": boolean,
    "opportunityId": string
}
export interface CreateFundBookingInput {
    "shareCount": number,
    "unitPrice": number,
    "totalPrice": number,
    "totalPriceWithVatAndCommission": number,
    "opportunityId": string,
    "isAcceptSustainabilityReport": boolean,
    "isAcceptCustomerAcknowledgement": boolean,
    "otp": string,
    "investorSignature"?: string,
}
export interface OpportunityItemDto {
    actualUnitPrice: number;
    averageRate: number;
    commissionPerUnit: number;
    commissionVat: number;
    commissionVatPerUnit: number;
    companyAddress: string;
    companyAddressAr: string;
    companyAddressEn: string;
    companyDescription: string;
    companyDescriptionAr: string;
    companyDescriptionEn: string;
    companyId: string;
    companyLatitude: number;
    companyLongitude: number;
    companyName: string;
    companyNameAr: string;
    companyType: string;
    companylogoUrl: string | null;
    companynameEn: string;
    contactEmail: string;
    contactFax: string | null;
    contactPerson: string;
    contactPhone: string;
    custodianName: string;
    custodianNameAr: string;
    custodianNameEn: string;
    coverPhotoURL?: string;
    dividendPolicy: string;
    dividendPolicyAr: string;
    dividendPolicyen: string;
    durationPerMonth: number;
    expectedTotalProfit: number;
    facebookURL: string;
    fundLocation: string;
    fundLocationAr: string;
    fundLocationEn: string;
    fundManagerName: string;
    fundManagerNameAr: string;
    fundManagerNameEn: string;
    fundName: string;
    fundNameAr: string;
    fundNameEn: string;
    fundStrategyName: string;
    fundStrategyNameAr: string;
    fundStrategyNameEn: string;
    fundType: string;
    fundingPolicy: string;
    fundingPolicyAr: string;
    fundingPolicyEn: string;
    instagramURL: string;
    intervalProfit: number;
    investmentEndDate: string;
    investmentFundId: string;
    investmentFundLogoUrl: string | null;
    investmentStartDate: string;
    isAcceptCustomerAcknowledgement: boolean;
    isAcceptSustainabilityReport: boolean;
    isCompleted: boolean;
    isFundClosed: boolean;
    isInCompleted: boolean;
    isInclusive: boolean;
    isUpcoming: boolean;
    janaCommission: number;
    janaCoverageShare: number;
    linkedInURL: string;
    maximumInvestment: number;
    minimumInvestment: number;
    opportunityid: string;
    organizerName: string | null;
    organizerNameAr: string | null;
    organizerNameEn: string | null;
    projectIdea: string;
    projectIdeaAr: string;
    projectIdeaEn: string;
    projectTotalValue: number;
    regualatorName: string;
    regualatorNameAr: string;
    regualatorNameEn: string;
    reviewsCount: number;
    shariahSupervisoryName: string;
    shariahSupervisoryNameAr: string;
    shariahSupervisoryNameEn: string;
    soldPercentage: number;
    soldUnits: number;
    subscriptionsNetWorth: number | null;
    totalUnits: number;
    twitterURL: string;
    unitPrice: number;
    websiteURL: string;
    youTubeURL: string | null;
    establishmentPrice: number | null;
    ytdPrice: number | null;
    percentageOfChange: number | null;
}
export enum BorrowerFundingType {
  PurchaseOrderFinancing = 0,
}

export interface FundingDetails {
  paymentPeriod: number;
  fundingType: BorrowerFundingType;
  requiredAmount: number;
  beneficiaryName: string;
  supplierName: string;
  supplierResponsibleName: string;
  supplierResponsiblePhone: string;
  /** Free-text notes for the funding request (optional). */
  additionalNotes?: string | null;
  FundApplicationId: string;
}

export interface SubmitFundingDetailsRequest {
  paymentPeriod: number;
  fundingType: BorrowerFundingType;
  requiredAmount: number;
  beneficiaryName: string;
  supplierName: string;
  supplierResponsibleName: string;
  supplierResponsiblePhone: string;
  /** Optional; sent on SubmitFundingDetails / SaveDraftFundingDetails. */
  additionalNotes?: string | null;
  FundApplicationId: string;
}
export interface InitFund{
  fundId: string;
  applicationNum: string;
  isSubmitted: boolean;
}
export interface FundApplicationDto{
  Id:string;
  applicantId:string;
  companyName:string;
  requestAmount:number;
  creationDate:string;
  status:string;
  notes:string;
  canEdit:boolean;
}
export interface SignAgreementRequest {
  fundId: string;
  otp: string;
}

export interface RejectBorrowerFinancingAgreementRequest {
  fundId: string;
  reason: string;
}

export interface FundingDetailsResponse {
  id: string;
  userId: string;
  paymentPeriod: number;
  fundingType?: BorrowerFundingType | null;
  requiredAmount: number;
  beneficiaryName: string;
  supplierName: string;
  supplierResponsibleName: string;
  supplierResponsiblePhone: string;
  additionalNotes?: string | null;
  /** .NET default JSON may use PascalCase. */
  AdditionalNotes?: string | null;
  offerPriceDocument?: string;
  offerPriceDocumentStoredFileId?: string;
  offerPriceDocumentUrl?: string;
  /** Absolute https OSS URL when the file has been pushed to object storage. */
  offerPriceDocumentOssUrl?: string;
  createdAt?: string;
  updatedAt?: string;
}

export class FirstStepData {
  fundId?: string;
  clientInfo!: ClientInfoDto;
  authorizedPerson!: AuthorizedPersonDto;
  /** Borrower fund step 1: applicant (user) — maps to API `ApplicantNationalAddress` (`NationalAddress`, includes `unitNumber`). */
  applicantNationalAddress?: NationalAddressDto;
  companyNationalAddress?: NationalAddressDto;
}
export enum FundTypeEnum {
    OpenFund = "OpenFund",
    CloseFund = "CloseFund",

}
export enum EFundStatus {
    Upcoming = 0,
    Current = 1,
    Ended = 2
}

